const VIP_OFFICE_PRICE_PER_POSITION_TABLE = [
  {
    keywords: ["paulista", "vila olímpia", "vila olimpia"],
    pricePerPosition: 1450,
  },
  { keywords: ["barra funda", "rio de janeiro"], pricePerPosition: 1050 },
  { keywords: ["pinheiros"], pricePerPosition: 1900 },
  { keywords: ["paraíso", "paraiso"], pricePerPosition: 1300 },
  { keywords: ["vila mariana"], pricePerPosition: 950 },
];

export const getVipOfficePricePerPosition = (
  label: string,
  spaceName: string,
  neighborhood: string,
  cityname: string,
): number => {
  const searchStr =
    `${label} ${spaceName} ${neighborhood} ${cityname}`.toLowerCase();
  return (
    VIP_OFFICE_PRICE_PER_POSITION_TABLE.find((entry) =>
      entry.keywords.some((kw) => searchStr.includes(kw)),
    )?.pricePerPosition ?? 0
  );
};
